<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 28.10.2022
  -- Description : Liste des ARE
  -- Fichier : JobSearchAssistanceList.vue
  -->

<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <CreateJobSearchAssistanceFromList />
      </v-col>
      <v-col cols="12" md="4"> </v-col>
      <v-col cols="12" md="4" class="pt-0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
          @click="updatePageSearch"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="jobSearchAssistance.jobSearchAssistances"
      :items-per-page="settings.itemsPerPage"
      :search="search"
      class="elevation-1"
      @click:row="selectRow"
      @update:items-per-page="updateNumberItems"
      :options.sync="options"
    >
      <template v-slot:item.date="{ item }">
        {{ formatDate(item.date) }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import store from '@/store/index.js'
import { mapState } from 'vuex'
import CreateJobSearchAssistanceFromList from '@/components/CreateJobSearchAssistanceFromList.vue'
import moment from 'moment'

function getJobSearchAssistance(routeTo, next) {
  store
    .dispatch('jobSearchAssistance/fetchJobSearchAssistances', true)
    .then(() => {
      next()
    })
}

function loadData(routeTo, routeFrom, next) {
  getJobSearchAssistance(routeTo, next)
}

export default {
  components: {
    CreateJobSearchAssistanceFromList
  },

  data: () => ({
    options: {},
    search: '',
    headers: [
      {
        text: 'Adresse',
        value: 'address'
      },
      {
        text: 'Ville',
        value: 'town'
      },
      {
        text: 'Code postal',
        value: 'zipCode'
      },
      {
        text: 'Occurrence',
        value: 'typeJobSearchAssistanceOccurrence.description'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Description',
        value: 'description'
      },
      {
        text: 'Site internet',
        value: 'website'
      },
      {
        text: 'Mots clés',
        value: 'keyWords'
      },
      {
        text: 'Type',
        value: 'typeJobSearchAssistance.description'
      }
    ],
    jobSearchAssistances: []
  }),

  beforeRouteEnter(routeTo, routeFrom, next) {
    loadData(routeTo, routeFrom, next)
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    loadData(routeTo, routeFrom, next)
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    // Sauvegarde le numéro de page consulté du tableau are avant de changer de page
    store
      .dispatch('settings/setCurrentPageJobSearchAssistance', {
        number: this.options.page
      })
      .then(() => {})
    next()
  },

  created() {
    // Récupère le dernier numéro de page consulté
    this.options.page = store.state.settings.currentPageJobSearchAssistance
  },

  computed: {
    ...mapState(['jobSearchAssistance', 'settings'])
  },

  methods: {
    // Lorsqu'une donnée est selectionnée dans le tableau, redirige vers le formulaire de modification
    selectRow(event) {
      this.$router.push({
        name: 'JobSearchAssistance-Modifier',
        params: { id: event.jobSearchAssistanceId }
      })
    },
    // Met à jour le nombre d'élément à afficher dans un tableau
    updateNumberItems(event) {
      store
        .dispatch('settings/setItemsPerPage', {
          number: event
        })
        .then(() => {})
    },
    // Quand une recherche est effectuée, partir de la première page
    updatePageSearch() {
      this.options.page = 1
    },
    formatDate: function(date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
    }
  }
}
</script>
